import MuiPagination from '@mui/material/Pagination';
import { useRecoilState, useRecoilValue } from 'recoil';

import { constants } from 'lib/constants';
import { marketplaceFiltersState } from 'lib/recoil/atoms';
import { filteredProductsState } from 'lib/recoil/selectors';

export const Pagination = () => {
	const { count } = useRecoilValue(filteredProductsState);
	const [marketplaceFilters, setMarketplaceFilters] = useRecoilState(marketplaceFiltersState);

	const handleOnPaginationChange = (event: React.ChangeEvent<unknown>, value: number) => {
		window.scrollTo(0, 0);

		setMarketplaceFilters(prevState => ({
			...prevState,
			pagination: value
		}));
	};

	return (
		<MuiPagination
			count={Math.ceil(count / constants.PAGE_SIZE)}
			page={marketplaceFilters.pagination}
			color='primary'
			onChange={handleOnPaginationChange}
			showFirstButton
			showLastButton
		/>
	);
};
